document.addEventListener('DOMContentLoaded', function () {
  eventListeners();
  limpiarAlertas();
  enviado();
});
function enviado() {
  const formulario = document.querySelector('.form');

  if (formulario) {
    formulario.addEventListener('submit', function () {
      // Muestra la alerta de éxito después de enviar el formulario
        Swal.fire({
          title: '¡Gracias por tu mensaje!',
          text: 'Nos pondremos en contacto contigo pronto.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        }).then(() => {
            // Aquí el formulario se envía después de la alerta
            formulario.submit(); // Enviar el formulario de forma tradicional
        });
    })
  }
}

const formulariosEliminar = document.querySelectorAll('.formulario-eliminar');

formulariosEliminar.forEach(formulario => {
  formulario.addEventListener('submit', function (e) {
    e.preventDefault();

    Swal.fire({
      title: '¿Estás seguro de eliminar este vehículo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        popup: 'my-popup', // Contenedor del popup
        title: 'my-title', // Título
        icon: 'my-icon',
        content: 'my-content', // Contenido
        confirmButton: 'my-confirm-btn', // Botón de confirmación
        cancelButton: 'my-cancel-btn' // Botón de cancelación
      }
    }).then((result) => {
      if(result.isConfirmed){
        formulario.submit();
      }
    });
  });
});

function limpiarAlertas() {
  const mensajeConfirm = document.querySelector('.alerta.exito');
  if(mensajeConfirm !== null){
      setTimeout(function () {
          const padre = mensajeConfirm.parentElement;
          padre.removeChild(mensajeConfirm);
      }, 3500);
      console.log("Hay mensaje de error");
  }else{
      console.log("No hay mensaje de error");
  }
}

function eventListeners() {
  const hamburger = document.querySelector(".menu");
  hamburger.addEventListener("click", toggleMenu)
}

function toggleMenu() {
  const menu = document.querySelector(".header__mobile");
  const closeMenu = document.querySelector("#equis");
  const openMenu = document.querySelector("#hamburguesa");

  if (menu.classList.contains("menu-active")) {
    menu.classList.remove("menu-active");
    closeMenu.style.display = "none";
    openMenu.style.display = "block";
    // Elimina la clase que desactiva el scroll
    document.body.classList.remove("body-no-scroll");
  } else {
    menu.classList.add("menu-active");
    closeMenu.style.display = "block";
    openMenu.style.display = "none";
    // Añade la clase que desactiva el scroll
    document.body.classList.add("body-no-scroll");
  }
}

const modoOscuroLocalStorage = localStorage.getItem('modo-oscuro');
const prefiereDarkmode = window.matchMedia('(prefers-color-scheme: dark)');
const toggleButton = document.getElementById("darkMode-icon");
const body = document.body;

// Función para aplicar las clases de modo oscuro
function aplicarModoOscuro(activarModoOscuro) {
  if (activarModoOscuro) {
    body.classList.add('dark-mode');
    toggleButton.classList.add('bxs-sun');
  } else {
    body.classList.remove('dark-mode');
    toggleButton.classList.remove('bxs-sun');
  }
}

// Función para manejar la preferencia del usuario y el almacenamiento local
function actualizarModoOscuroEnStorage(activarModoOscuro) {
  localStorage.setItem('modo-oscuro', activarModoOscuro ? 'true' : 'false');
}

// Inicializa el modo oscuro según la preferencia del usuario o el valor predeterminado
function inicializarModoOscuro() {
  if (modoOscuroLocalStorage === 'true') {
    aplicarModoOscuro(true);
  } else if (modoOscuroLocalStorage === 'false') {
    aplicarModoOscuro(false);
  } else if (prefiereDarkmode.matches) {
    aplicarModoOscuro(true);
  } else {
    aplicarModoOscuro(false);
  }
}

// Escuchar cambios en la preferencia de color del sistema (modo oscuro)
prefiereDarkmode.addEventListener('change', function() {
  const modoOscuroActivo = prefiereDarkmode.matches;
  aplicarModoOscuro(modoOscuroActivo);
  actualizarModoOscuroEnStorage(modoOscuroActivo);
});

// Alternar el modo oscuro con el clic en el botón
toggleButton.addEventListener('click', function() {
  const modoOscuroActivo = body.classList.contains('dark-mode');
  aplicarModoOscuro(!modoOscuroActivo);
  actualizarModoOscuroEnStorage(!modoOscuroActivo);
});

// Función de accesibilidad: cambiar estado de activación del modo oscuro
function actualizarAccesibilidad() {
  toggleButton.setAttribute('aria-pressed', body.classList.contains('dark-mode'));
}

// Inicializar el modo oscuro y la accesibilidad al cargar
inicializarModoOscuro();
actualizarAccesibilidad();

// Actualizar el estado de accesibilidad cada vez que cambie el modo oscuro
toggleButton.addEventListener('click', actualizarAccesibilidad);


ScrollReveal({
  reset: true,
  distance: '80px',
  duration: 2000,
  deley: 200
});

ScrollReveal().reveal('.home-content h1, .home-content img, .paquetes-promocionales, #mapa', { origin: 'top' });
ScrollReveal().reveal('.titulo-seccion, .titulo-seccion2, .down-btns, .btn-banner, .btn-terminos' , { origin: 'bottom' });
ScrollReveal().reveal('.home-content p, .iconos, .requisitos-container, #formulario-contacto', { origin: 'left'});
ScrollReveal().reveal('.anuncio, #contacto-directo', { origin: 'right'});